import { Dropdown } from "@circle-react-uikit/Dropdown";
import { ToggleSwitchWithLabel } from "@circle-react/components/shared/uikit/ToggleSwitchWithLabel";

import { t } from "@/i18n-js/instance";
import type { Event } from "@/react/types/Event";

import { useEventMenu } from "./hooks/useEventMenu";

interface PinEventToTopActionProps {
  canEdit?: boolean;
  event: Event;
}

export const PinEventToTopAction = ({
  canEdit,
  event,
}: PinEventToTopActionProps) => {
  const isPinned = event.pinned_at_top_of_space;
  const { onPinToTop } = useEventMenu({ event });
  if (!canEdit) {
    return null;
  }

  return (
    <Dropdown.ItemLink onClick={onPinToTop}>
      <ToggleSwitchWithLabel
        label={t("pin_to_space")}
        field="pin_to_top"
        value={isPinned}
        variant="small"
      />
    </Dropdown.ItemLink>
  );
};
